/* VSS Adaptive Smart Search 2.3.1 Fase 1. Native Shopify Section Rendering, no dependencies. */
(() => {
  if (customElements.get('vss-smart-search')) return;
/* Query interpretation shared by the panel, refinements and full search links. */
const VSSIntent = (() => {
  const config = {"families":[{"key":"bags","aliases":["rope bag","rope bags","sail bag","sail bags","bag","bags"],"guide":"Check capacity, closure and carrying options for the equipment you need to carry.","terms":["bag","bags"]},{"key":"lifelines","aliases":["lifeline","lifelines"],"guide":"Check fitting dimensions and your existing lifeline system before choosing components.","terms":["lifeline","lifelines"]},{"key":"pfds","aliases":["life jacket","life jackets","lifejacket","lifejackets","lifevest","lifevests","pfd","pfds","buoyancy aid","buoyancy aids"],"guide":"Compare activity, fit and the certification stated on each product page.","terms":["pfd","lifejacket","life jacket","lifevest","buoyancy aid"]},{"key":"gloves","aliases":["glove","gloves","gloevs"],"guide":"Narrow by finger coverage and weather, then check the size guide on the product page.","terms":["glove","gloves"]},{"key":"footwear","aliases":["sailing boots","sailing shoes","boot","boots","shoe","shoes","footwear"],"guide":"Compare boot or shoe style, intended use and sizing before choosing.","terms":["boot","boots","shoe","shoes"]},{"key":"wetsuits","aliases":["wetsuit","wetsuits","long john","longjohn"],"guide":"Compare thickness, coverage and sizing for your sailing conditions.","terms":["wetsuit","long john","longjohn"]},{"key":"drysuits","aliases":["drysuit","drysuits","dry suit","dry suits"],"guide":"Check sizing, seal details and layering requirements on the product page.","terms":["drysuit","drysuits","dry suit","dry suits"]},{"key":"jackets","aliases":["jacket","jackets","smock","smocks","spray top","spray tops","aquafleece"],"guide":"Compare coverage, fabric and intended conditions, then check sizing.","terms":["jacket","jackets","smock","spraytop","spray top","aquafleece"]},{"key":"headwear","aliases":["hat","hats","cap","caps","headwear","beanie","beanies"],"guide":"Compare fit, coverage and retention details for use on the water.","terms":["hat","hats","cap","caps"]},{"key":"sunglasses","aliases":["sunglass","sunglasses"],"guide":"Check lens details, fit and retention options on the product page.","terms":["sunglass","sunglasses"]},{"key":"watches","aliases":["watch","watches"],"guide":"Compare timer functions, display and strap fit for your intended use.","terms":["watch","watches"]},{"key":"harnesses","aliases":["harness","harnesses"],"guide":"Check the intended harness type and sizing; trapeze and safety harnesses serve different uses.","terms":["harness","harnesses"]},{"key":"tops","aliases":["rashguard","rashguards","rash guard","rash guards","base layer","base layers"],"guide":"Compare coverage, fabric and layering options, then check the size guide.","terms":["rashguard","rash guard","base layer"]},{"key":"blocks","aliases":["block","blocks","pulley","pulleys"],"guide":"Narrow by configuration and sheave size. Check rope diameter and working load on the product page.","terms":["block","blocks","pulley","pulleys"],"types":["Blocks","Double Blocks","Fiddle Blocks","Quad Blocks","Ratchet Blocks","Single Blocks","Snatch Blocks","Triple Blocks"]},{"key":"winches","aliases":["winch","winches"],"guide":"Compare manual or powered operation, size and configuration; verify mounting details.","terms":["winch","winches"]},{"key":"cleats","aliases":["cleat","cleats"],"guide":"Compare cleat type, accepted line diameter and mounting pattern.","terms":["cleat","cleats"]},{"key":"clutches","aliases":["clutch","clutches","rope clutch","rope clutches","stopper","stoppers"],"guide":"Compare accepted line diameter, holding load and mounting details.","terms":["clutch","clutches","rope clutch","rope clutches"]},{"key":"shackles","aliases":["shackle","shackles"],"guide":"Compare opening, pin diameter, material and working load for the intended connection.","terms":["shackle","shackles"]},{"key":"turnbuckles","aliases":["turnbuckle","turnbuckles"],"guide":"Check thread size, end fittings and adjustment range against your existing rigging.","terms":["turnbuckle","turnbuckles"]},{"key":"tracks","aliases":["track","tracks","traveler","travelers","traveller","travellers"],"guide":"Match the track profile, car series and dimensions; similar widths do not establish compatibility.","terms":["track","tracks","traveler","travelers"]},{"key":"furling","aliases":["furler","furlers","furling"],"guide":"Identify the sail and furling system, then check model-specific compatibility.","terms":["furler","furlers","furling"]},{"key":"rigging","aliases":["standing rigging","rigging terminal","rigging terminals","wire terminal","wire terminals","rigging cable","rigging wire"],"guide":"Match wire diameter, terminal type and dimensions with your rigging specification.","terms":["standing rigging","rigging terminal","rigging terminals","wire terminal","rigging cable","rigging wire"]},{"key":"ropes","aliases":["rope","ropes","line","lines","halyard","halyards","sheet","sheets","dyneema"],"guide":"Choose by application, diameter and length. Check the selling unit and construction on the product page.","terms":["rope","line","halyard"]},{"key":"compasses","aliases":["compass","compasses"],"guide":"Compare the display, mounting and functions you need for navigation or racing.","terms":["compass","compasses"]},{"key":"wind","aliases":["wind indicator","wind indicators","wind instrument","wind instruments","anemometer","anemometers"],"guide":"Check mounting, measurement functions and compatibility with your instrument system.","terms":["wind indicator","wind indicators","wind instrument","wind instruments"]},{"key":"electronics","aliases":["gps","instrument","instruments","electronics","race computer"],"guide":"Compare functions, mounting and system connections; check accessories separately.","terms":["instrument","instruments","gps","race computer"]},{"key":"covers","aliases":["cover","covers"],"guide":"Match the boat or equipment model and check coverage and dimensions.","terms":["cover","covers"]},{"key":"dollies","aliases":["dolly","dollies"],"guide":"Match the boat model, support arrangement and transport requirements.","terms":["dolly","dollies"]},{"key":"sails","aliases":["sail","sails"],"guide":"Match your boat and sail size. For racing, verify class legality in the product documentation.","terms":["sail","sails"]},{"key":"tillers","aliases":["tiller","tillers","tiller extension","tiller extensions"],"guide":"Match the boat, connection type and length; verify class legality where required.","terms":["tiller","tillers","tiller extension","tiller extensions"]},{"key":"rudders","aliases":["rudder","rudders","centerboard","centerboards","centreboard","centreboards"],"guide":"Match the boat and fittings. For racing, verify class legality in the product documentation.","terms":["rudder","rudders","centerboard","centerboards"]},{"key":"anchors","aliases":["anchor","anchors","anchoring"],"guide":"Compare dimensions and the manufacturer's selection guidance for your boat and use.","terms":["anchor","anchors","anchoring"]},{"key":"pumps","aliases":["pump","pumps","bailer","bailers"],"guide":"Compare capacity, installation dimensions and manual or powered operation.","terms":["pump","pumps","bailer","bailers"]},{"key":"cleaners","aliases":["cleaner","cleaners","cleaning","polish","polishes"],"guide":"Check the intended surface and application instructions before choosing a cleaner.","terms":["cleaner","cleaners","cleaning","polish"]},{"key":"fasteners","aliases":["screw","screws","bolt","bolts","fastener","fasteners","pin","pins"],"guide":"Match diameter, length, thread and material to the original specification.","terms":["screw","screws","bolt","bolts"]}],"brands":[{"key":"harken","aliases":["harken"],"vendors":["Harken","Harken Canvas and Covers","Harken Sport"],"label":"Harken"},{"key":"ronstan","aliases":["ronstan"],"vendors":["Ronstan Sailboat Hardware","Ronstan Sailing Gear"],"label":"Ronstan"},{"key":"allen","aliases":["allen brothers","allen"],"vendors":["Allen Brothers"],"label":"Allen Brothers"},{"key":"antal","aliases":["antal"],"vendors":["Antal"],"label":"Antal"},{"key":"selden","aliases":["selden"],"vendors":["Selden","Selden Mast"],"label":"Selden"},{"key":"lewmar","aliases":["lewmar"],"vendors":["Lewmar"],"label":"Lewmar"},{"key":"nautos","aliases":["nautos"],"vendors":["Nautos"],"label":"Nautos"},{"key":"wichard","aliases":["wichard"],"vendors":["Wichard"],"label":"Wichard"},{"key":"spinlock","aliases":["spinlock"],"vendors":["Spinlock"],"label":"Spinlock"},{"key":"karver","aliases":["karver"],"vendors":["Karver Systems"],"label":"Karver"},{"key":"nodus","aliases":["nodus factory","nodus"],"vendors":["Nodus"],"label":"Nodus Factory"},{"key":"sea-sure","aliases":["sea sure"],"vendors":["Sea Sure"],"label":"Sea Sure"},{"key":"tylaska","aliases":["tylaska"],"vendors":["Tylaska"],"label":"Tylaska"},{"key":"colligo","aliases":["colligo marine","colligo"],"vendors":["Colligo Marine"],"label":"Colligo Marine"},{"key":"sparcraft","aliases":["sparcraft"],"vendors":["Sparcraft"],"label":"Sparcraft"},{"key":"gill","aliases":["gill sailing gear","gill"],"vendors":["Gill Sailing Gear"],"label":"Gill Sailing Gear"},{"key":"zhik","aliases":["zhik sailing gear","zhik"],"vendors":["Zhik Sailing Gear"],"label":"Zhik Sailing Gear"},{"key":"rooster","aliases":["rooster sailing","rooster"],"vendors":["Rooster Sailing"],"label":"Rooster Sailing"},{"key":"vaikobi","aliases":["vaikobi"],"vendors":["Vaikobi"],"label":"Vaikobi"},{"key":"helly-hansen","aliases":["helly hansen"],"vendors":["Helly Hansen"],"label":"Helly Hansen"},{"key":"mustang","aliases":["mustang survival","mustang"],"vendors":["Mustang Survival"],"label":"Mustang Survival"},{"key":"mti","aliases":["mti life jackets","mti"],"vendors":[],"label":"Mti Life Jackets"},{"key":"magic-marine","aliases":["magic marine"],"vendors":[],"label":"Magic Marine"},{"key":"marlow","aliases":["marlow ropes","marlow"],"vendors":["Marlow Ropes"],"label":"Marlow Ropes"},{"key":"samson","aliases":["samson ropes","samson"],"vendors":["Samson"],"label":"Samson Ropes"},{"key":"new-england","aliases":["new england ropes","new england"],"vendors":["New England Ropes"],"label":"New England Ropes"},{"key":"alpha","aliases":["alpha ropes"],"vendors":["Alpha Ropes"],"label":"Alpha Ropes"},{"key":"liros","aliases":["liros"],"vendors":[],"label":"Liros"},{"key":"robline","aliases":["robline"],"vendors":["Robline"],"label":"Robline"},{"key":"yale","aliases":["yale cordage","yale"],"vendors":["Yale Cordage"],"label":"Yale Cordage"},{"key":"cousin","aliases":["cousin"],"vendors":[],"label":"Cousin"},{"key":"robship","aliases":["robship"],"vendors":["Robship"],"label":"Robship"},{"key":"hayn","aliases":["hayn marine","hayn"],"vendors":["Hayn"],"label":"Hayn Marine"},{"key":"sta-lok","aliases":["sta lok"],"vendors":["Sta-Lok Terminals"],"label":"Sta Lok"},{"key":"johnson","aliases":["johnson marine"],"vendors":["Johnson Marine"],"label":"Johnson Marine"},{"key":"schaefer","aliases":["schaefer marine","schaefer"],"vendors":["Schaefer"],"label":"Schaefer Marine"},{"key":"andersen","aliases":["andersen"],"vendors":["Andersen Bailers","Andersen","Andersen Winches"],"label":"Andersen"},{"key":"facnor","aliases":["facnor"],"vendors":["Facnor Furlers"],"label":"Facnor"},{"key":"profurl","aliases":["profurl"],"vendors":["Profurl Furlers"],"label":"Profurl"},{"key":"cdi","aliases":["cdi"],"vendors":["CDI Flexible Furlers"],"label":"Cdi"},{"key":"forespar","aliases":["forespar"],"vendors":["Forespar"],"label":"Forespar"},{"key":"clamcleat","aliases":["clamcleat"],"vendors":["Clamcleat"],"label":"Clamcleat"},{"key":"optiparts","aliases":["optiparts"],"vendors":["Optiparts"],"label":"Optiparts"},{"key":"windesign","aliases":["windesign"],"vendors":[],"label":"Windesign"},{"key":"garmin","aliases":["garmin"],"vendors":["Garmin GPS Watches"],"label":"Garmin"},{"key":"vakaros","aliases":["vakaros"],"vendors":["Vakaros"],"label":"Vakaros"},{"key":"velocitek","aliases":["velocitek"],"vendors":["Velocitek"],"label":"Velocitek"},{"key":"sailmon","aliases":["sailmon"],"vendors":[],"label":"Sailmon"},{"key":"novasail","aliases":["novasail"],"vendors":["Novasail Tactical Instruments"],"label":"Novasail"},{"key":"tacktick","aliases":["tacktick"],"vendors":["Tacktick"],"label":"Tacktick"},{"key":"calypso","aliases":["calypso"],"vendors":["Calypso Instruments"],"label":"Calypso"},{"key":"raymarine","aliases":["raymarine"],"vendors":["Raymarine"],"label":"Raymarine"},{"key":"standard-horizon","aliases":["standard horizon"],"vendors":["Standard Horizon"],"label":"Standard Horizon"},{"key":"blue-performance","aliases":["blue performance"],"vendors":["Blue Performance"],"label":"Blue Performance"},{"key":"dynamic","aliases":["dynamic dollies"],"vendors":["Dynamic Dollies"],"label":"Dynamic Dollies"}]};
  const norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/(\d)\s+mm\b/g, '$1mm').replace(/['’]/g, '').replace(/[^a-z0-9.$]+/g, ' ').replace(/\s+/g, ' ').trim();
  const has = (text, phrase) => (` ${norm(text)} `).includes(` ${norm(phrase)} `);
  const quote = value => `"${String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
  const or = clauses => clauses.length === 1 ? clauses[0] : `(${clauses.join(' OR ')})`;
  const stop = new Set('a an the for with and by of to in on sailing sailboat boat marine supply gear please need want looking i me my weather conditions diameter sheave size'.split(' '));
  const features = {
    blocks:['single','double','triple','quad','ratchet','snatch','fiddle','becket','swivel','fixed','manual','automatic','cheek','carbo','zircon','bullet','t2'],
    gloves:['short finger','long finger','full finger','neoprene'],
    winches:['self tailing','electric','manual'],
    shackles:['soft','snap','bow','twisted'],
    clutches:['single','double','triple'],
    bags:['dry','rope'],
    jackets:['hooded','neoprene','offshore','coastal'],
    ropes:['dyneema','polyester'],
    pfds:['inflatable'],
    footwear:['neoprene'],
    cleats:['cam','clam','horn']
  };
  // Merchant-owned rules are rendered by the visual editor section, as inert JSON.
  let rulesNode, loadedRules=[];
  function rules() {
    const node=typeof document!=='undefined'?document.querySelector('template[data-vss-search-settings]'):null;
    if(node===rulesNode)return loadedRules;
    rulesNode=node;
    loadedRules=node?[...node.content.querySelectorAll('[data-vss-rule]')].flatMap(el=>{
      try {
        const r=JSON.parse(el.getAttribute('data-vss-rule'));
        r.choices=(r.choices||[]).filter(c=>c.label?.trim()&&c.query?.trim());
        return r.enabled?[r]:[];
      }catch{return [];}
    }):[];
    return loadedRules;
  }
  function ruleScore(r,text,family='') {
    if(r.match==='family')return r.family&&r.family===family?1:0;
    let score=r.match==='family_phrase' && r.family && r.family===family?1:0;
    for(const line of String(r.keywords||'').split(/\r?\n/)) {
      const key=norm(line);if(!key)continue;
      const matches=r.match==='exact'?text===key:r.match==='words'?key.split(' ').every(w=>has(text,w)):has(text,key);
      if(matches)score=Math.max(score,100+key.length+(r.match==='exact'?1000:0));
    }
    return score;
  }
  function selectRule(text,family='',modes=['guide']) {
    return rules().filter(r=>modes.includes(r.mode)).map((r,index)=>({r,index,score:ruleScore(r,text,family)}))
      .filter(x=>x.score).sort((a,b)=>b.score-a.score||a.index-b.index)[0]?.r||null;
  }
  function translateRule(text,r) {
    if(!r||!['alias','assist'].includes(r.mode)||!r.target?.trim())return text;
    // Only phrase matches can be replaced in place. Exact/word matches use the
    // destination as a whole; the editor explains this distinction.
    if(!['phrase','family_phrase'].includes(r.match))return norm(r.target);
    const key=String(r.keywords||'').split(/\r?\n/).map(norm).filter(x=>x&&has(text,x)).sort((a,b)=>b.length-a.length)[0];
    return key?(` ${text} `).replace(` ${key} `,` ${norm(r.target)} `).trim():text;
  }
  function publicSettings() {
    const node=typeof document!=='undefined'?document.querySelector('template[data-vss-search-settings]'):null;
    return {natural:node?.dataset.naturalSearch!=='false'};
  }
  function waterproofEvidence(p,title) {
    if(p.waterproof===true)return true;
    if(p.waterproof===false)return false;
    const description=String(p.body||'').replace(/<[^>]*>/g,' ');
    const negative=/\b(?:not waterproof|non waterproof|not fully waterproof|water resistant only)\b/;
    if(negative.test(norm(description)))return false;
    if(has(title,'waterproof'))return true;
    return description.split(/[.!?;\n]+/).some(sentence=>{
      const s=norm(sentence);
      if(!has(s,'waterproof'))return false;
      if(/\b(?:under|beneath|underneath|pair(?:ed|ing)? with|wear with|worn with|add|additional)\b.{0,70}\bwaterproof\b/.test(s))return false;
      if(/\bwaterproof\b.{0,60}\b(?:sold separately|required|not included)\b/.test(s))return false;
      return /\b(?:waterproof (?:and |breathable |pu |shell|outer|protect|rating|fabric|membrane|tech)|fully waterproof|is waterproof|its waterproof|2 layer waterproof|3 layer waterproof|waterproofness)\b/.test(s);
    });
  }

  const factCache = new WeakMap();
  const familyAliases=config.families.map(f=>({...f,normalized:f.aliases.map(norm)}));
  const brandAliases=config.brands.map(b=>({...b,normalized:b.aliases.map(norm)}));
  const containsNormalized=(text,phrase)=>(` ${text} `).includes(` ${phrase} `);
  function familyOf(text, type = '') {
    const t = norm(text), pt = norm(type);
    if (/\b(rope|line) (bag|bags)\b/.test(t)) return 'bags';
    if (/\b(jacket splice|anti chafe sleeve)\b/.test(t)) return '';
    if (/\b(lifejacket|life jacket|lifevest|pfd)\b/.test(t) && /\b(light|cylinder|bottle|re arming|rearming|kit|cover)\b/.test(t)) return '';
    if (/\b(rope splicing tools|rope splices finishes)\b/.test(pt)) return '';
    if (/\b(?:aquafleece|jacket|wetsuit) repair kit\b/.test(t))return '';
    if (['ropes','running rigging','sailboat control lines'].includes(pt)) return 'ropes';
    // Product types disambiguate names such as “Block Microfleece Jacket”.
    for (const f of familyAliases) if (f.normalized.some(a => containsNormalized(pt, a))) return f.key;
    for (const f of familyAliases) if (f.normalized.some(a => containsNormalized(t, a))) return f.key;
    return '';
  }
  function brandOf(value) {
    const text=norm(value);
    return brandAliases.find(b => b.normalized.some(a => containsNormalized(text,a)))?.key || '';
  }
  function parse(raw) {
    let text = norm(raw).replace(/\bgloevs\b/g,'gloves').replace(/\brachet\b/g,'ratchet').replace(/\bwater proof\b/g,'waterproof');
    const i = { raw:String(raw).trim(), text, family:'', brand:'', brands:[], size:null, priceMax:null, priceMin:null, cold:false, waterproof:false,
      application:'', features:[], excluded:[], gender:'', audience:'', extra:[], changed:false, advanced:/\b(?:title|vendor|tag|product_type|variants\.[a-z]+):|\b(?:AND|OR)\b/.test(raw) };
    if (i.advanced) { i.query=raw; return i; }
    i.rule=selectRule(text,'',['alias','assist','clarify']);
    i.clarify=i.rule?.mode==='clarify' && (i.rule.choices||[]).some(c=>c.label&&c.query);
    const originalText=text;
    text=translateRule(text,i.rule);
    if(text!==originalText)i.changed=true;
    const novice = /\b(?:rope|line) to (?:pull up|raise|hoist)(?: the)? sail\b/.test(text);
    if (novice) { text = text.replace(/\b(?:rope|line) to (?:pull up|raise|hoist)(?: the)? sail\b/,'halyard'); i.changed=true; }
    const budget = text.match(/\b(under|below|less than|up to|max(?:imum)?|no more than)\s*(?:usd\s*)?\$?\s*(\d+(?:\.\d{1,2})?)\b/);
    if (budget) {
      i.priceMax=Math.round(Number(budget[2])*100) - (/^(under|below|less than)$/.test(budget[1]) ? 1 : 0);
      text=text.replace(budget[0],' '); i.changed=true;
    }
    const minimum = text.match(/\b(over|above|at least|min(?:imum)?)\s*(?:usd\s*)?\$?\s*(\d+(?:\.\d{1,2})?)\b/);
    if (minimum) {i.priceMin=Math.round(Number(minimum[2])*100)+(/^(over|above)$/.test(minimum[1])?1:0);text=text.replace(minimum[0],' ');i.changed=true;}
    i.family=familyOf(text);
    i.brands=config.brands.filter(b=>b.aliases.some(a=>has(text,a))).map(b=>b.key);
    i.brand=i.brands.length===1?i.brands[0]:'';
    i.cold=/\b(cold|colder|winter|thermal|insulated)\b/.test(text) && ['gloves','jackets','footwear','wetsuits','tops','headwear'].includes(i.family);
    i.waterproof=/\bwaterproof\b/.test(text);
    i.size=text.match(/\b(\d+(?:\.\d+)?)mm\b/)?.[1] || null;
    if (i.family==='ropes') {
      if (/\bhalyards?\b/.test(text)) i.application='halyard';
      else if (/\b(mainsheets?|main sheet)\b/.test(text)) i.application='mainsheet';
      else if (/\b(jib sheets?|jibsheets?)\b/.test(text)) i.application='jib sheet';
      else if (/\b(spinnaker sheets?)\b/.test(text)) i.application='spinnaker sheet';
      else if (/\b(dock|mooring)\b/.test(text)) i.application='mooring';
    }
    for (const f of features[i.family]||[]) if (has(text,f) || (f==='automatic' && has(text,'auto'))) {
      if(has(text,'without '+f)||has(text,'no '+f)) {i.excluded.push(f);text=text.replace('without '+f,' ').replace('no '+f,' ');}
      else i.features.push(f);
    }
    if (/\b(women|womens|female)\b/.test(text)) i.gender='women';
    else if (/\b(men|mens|male)\b/.test(text)) i.gender='men';
    if (/\b(junior|juniors|child|children|kids|youth)\b/.test(text)) i.audience='junior';
    let remainder=` ${text} `;
    const remove=[...(config.families.find(f=>f.key===i.family)?.aliases||[]), ...config.brands.filter(b=>i.brands.includes(b.key)).flatMap(b=>b.aliases), ...i.features];
    if(i.application)remove.push(i.application,i.application+'s');
    remove.sort((a,b)=>b.length-a.length).forEach(a=>{remainder=remainder.split(` ${norm(a)} `).join(' ');});
    remainder=remainder.replace(/\b\d+(?:\.\d+)?mm\b/g,' ').replace(/\b(auto|cold|colder|winter|thermal|insulated|waterproof|usd)\b/g,' ')
      .replace(/\b(women|womens|female|men|mens|male|junior|juniors|child|children|kids|youth)\b/g,' ');
    i.extra=remainder.trim().split(/\s+/).filter(t=>t&&!stop.has(t));
    i.constrained=!!(i.family&&(i.brand||i.brands.length||i.size||i.priceMax!==null||i.priceMin!==null||i.cold||i.waterproof||i.application||i.features.length||i.excluded.length||i.gender||i.audience||i.extra.length));
    i.canonical=text.trim().replace(/\s+/g,' ');
    i.guideRule=selectRule(originalText,i.family,['guide','assist']);
    if(i.rule?.guide || i.rule?.replaceCollections || i.rule?.choices?.length) i.guideRule={...i.guideRule,...i.rule};
    // Natural wording is sent as ordinary text so Shopify can use semantic
    // retrieval. Explicit technical searches keep structured retrieval.
    i.semantic=publicSettings().natural && !!(novice || ['alias','assist'].includes(i.rule?.mode) ||
      /\b(?:i need|i want|looking for|something|how to|what|which|to pull|to raise|to hoist|to lift|keep me|for my|necesito|para subir)\b/.test(originalText));
    i.query=i.semantic?i.canonical:buildQuery(i);
    return i;
  }
  function buildQuery(i) {
    if (!i.family || i.advanced) return i.raw;
    const f=config.families.find(f=>f.key===i.family);
    let clauses=[];
    if(i.family==='ropes') clauses.push(or(['product_type:"Ropes"','product_type:"Running Rigging"','product_type:"Sailboat Control Lines"','title:halyard*','title:rope*']));
    else clauses.push(or([...f.terms.map(t=>`title:${quote(t)}`),...(f.types||[]).map(t=>`product_type:${quote(t)}`)]));
    if(i.brands.length) {
      const vendors=config.brands.filter(b=>i.brands.includes(b.key)).flatMap(b=>b.vendors);
      if(vendors.length)clauses.push(or(vendors.map(v=>`vendor:${quote(v)}`)));
    }
    if(i.size) {
      const options=[`title:${quote(i.size+'mm')}`,`title:${quote(i.size+' mm')}`];
      if(i.family==='blocks'&&i.brands.includes('ronstan'))options.push(`title:${quote('Series '+i.size)}`);
      if(i.family==='ropes')options.push(`variants.title:${quote(i.size+'mm')}`,`variants.title:${quote(i.size+' mm')}`);
      clauses.push(or(options));
    }
    if(i.cold)clauses.push('(cold* OR thermal OR insulated OR insulation OR thinsulate OR title:"3 Season")');
    if(i.waterproof)clauses.push('waterproof');
    if(i.application)clauses.push(i.application==='mooring'?'(mooring OR dock)':quote(i.application));
    for(const a of i.features)clauses.push(a==='automatic'?'(title:auto OR title:automatic)':['neoprene','dyneema','polyester'].includes(a)?quote(a):`title:${quote(a)}`);
    for(const a of i.excluded)clauses.push(`-title:${quote(a)}`);
    if(i.gender==='women')clauses.push('(title:women OR title:womens OR title:"women\'s")');
    if(i.gender==='men')clauses.push('(title:men OR title:mens OR title:"men\'s")');
    if(i.audience)clauses.push('(title:junior* OR title:child* OR title:kids OR title:youth)');
    for(const t of i.extra)clauses.push(quote(t));
    return clauses.join(' AND ');
  }
  function url(intent, base, origin, type='') {
    const u=new URL(base,origin);
    u.searchParams.set('q',intent.constrained?intent.query:(intent.canonical||intent.raw));
    u.searchParams.set('options[prefix]','last');
    if(intent.constrained || intent.changed) {u.searchParams.set('type','product');u.searchParams.set('vss_query',intent.raw);}
    if(intent.priceMax!==null)u.searchParams.set('filter.v.price.lte',(intent.priceMax/100).toFixed(2));
    if(intent.priceMin!==null)u.searchParams.set('filter.v.price.gte',(intent.priceMin/100).toFixed(2));
    if(type)u.searchParams.set('filter.p.product_type',type);
    return u;
  }
  function facts(p) {
    if(factCache.has(p))return factCache.get(p);
    const title=norm(p.title), body=norm(p.body), type=norm(p.type);
    const collections=norm((p.collections||[]).join(' '));
    const family=familyOf(p.title,p.type), brand=brandOf(p.vendor);
    let size=String(p.sheave||'').match(/(\d+(?:\.\d+)?)/)?.[1];
    if(!size&&family==='blocks')size=title.match(/\b(\d+(?:\.\d+)?)mm\b/)?.[1] || (brand==='ronstan'?title.match(/\bseries (\d+)\b/)?.[1]:null);
    const cold=/\b(cold(?:er|est)?|thermal|thinsulate|insulat(?:ed|ion))\b/.test(title+' '+body)||/\b3 season\b/.test(title);
    const waterproof=waterproofEvidence(p,title);
    const result={family,brand,size,cold,waterproof,title,body,type,collections,
      gender:/\bwomens?\b/.test(title)?'women':/\bmens?\b/.test(title)?'men':'',
      audience:/\b(junior|juniors|child|children|kids|youth)\b/.test(title)?'junior':'',
      features:(features[family]||[]).filter(f=>has(title+' '+norm(p.configuration),f)||(f==='automatic'&&has(title,'auto'))||(['neoprene','dyneema','polyester'].includes(f)&&has(body,f)))};
    factCache.set(p,result);return result;
  }
  function match(p,i) {
    if(!i.family||i.advanced)return null;
    const f=facts(p);
    if(i.family && f.family!==i.family)return null;
    if(i.brands.length&&!i.brands.includes(f.brand))return null;
    if(i.size&&i.family==='blocks'&&Number(f.size)!==Number(i.size))return null;
    if(i.cold&&!f.cold)return null;
    if(i.waterproof&&!f.waterproof)return null;
    if(i.gender&&f.gender!==i.gender)return null;
    if(i.audience&&f.audience!==i.audience)return null;
    if(i.features.some(a=>!f.features.includes(a)))return null;
    if(i.excluded.some(a=>f.features.includes(a)))return null;
    const searchable=f.title+' '+f.body+' '+f.type+' '+f.collections+' '+norm((p.tags||[]).join(' '));
    if(!i.semantic && i.extra.some(t=>!has(searchable,t)&&!has(searchable,t+'s')))return null;
    if(i.family==='ropes' && /\b(?:clips?|halyard tail system|handles?|fittings?|end stops?|wire terminals?)\b/.test(f.title))return null;
    if(i.application==='halyard') {
      const sail=norm(i.canonical||i.raw).match(/\b(main|mainsail|jib|genoa|spinnaker)\b/)?.[1];
      const hay=f.title+' '+f.body+' '+f.collections;
      if(sail) {
        const accepted=sail==='main'||sail==='mainsail'?/\b(main|mainsail) halyards?\b/:sail==='jib'||sail==='genoa'?/\b(jib|genoa) halyards?\b/:/\bspinnaker halyards?\b/;
        if(!accepted.test(hay))return null;
      }
    }
    if(i.application) {
      const hay=f.title+' '+f.body+' '+f.collections;
      if(i.application==='mooring'?!/\b(mooring|dock)\b/.test(hay):!has(hay,i.application)&&!has(hay,i.application+'s'))return null;
      if(i.application==='halyard'&&/\b(anchor|mooring|dock|furler|furling)\b/.test(f.title))return null;
    }
    let variant=null;
    const variants=p.variants||[];
    const needsVariant=(i.size&&i.family==='ropes')||i.priceMax!==null||i.priceMin!==null;
    if(needsVariant) {
      const valid=variants.filter(v=> {
        if(i.priceMax!==null&&v.price>i.priceMax)return false;
        if(i.priceMin!==null&&v.price<i.priceMin)return false;
        if(i.size&&i.family==='ropes'&&!new RegExp(`\\b${i.size.replace('.','\\.')}mm\\b`).test(norm(v.title)))return false;
        return Number.isFinite(v.price);
      });
      if(!valid.length)return null;
      variant=valid.slice().sort((a,b)=>a.price-b.price)[0];
    }
    let score=10;
    if(i.cold&&/\b(cold|thermal|3 season|helmsman)\b/.test(f.title))score+=5;
    if(!i.audience&&f.audience==='junior')score-=2;
    if(i.waterproof&&has(f.title,'waterproof'))score+=2;
    return {product:p,facts:f,variant,score};
  }
  function guidance(i) {
    let text=i.guideRule?.guide||config.families.find(f=>f.key===i.family)?.guide||'Use a product name, brand or complete part number.';
    if(i.family==='blocks'&&i.size)text=`${i.size} mm refers to the sheave size, not the rope diameter. Check maximum line diameter and working load on each product page.`;
    if(i.family==='blocks'&&i.features.includes('ratchet'))text='Compare manual and automatic ratchet operation, attachment style and accepted rope diameter.';
    if(i.family==='ropes'&&i.application==='halyard')text='A halyard raises a sail. Choose the sail first, then check line diameter, length and stretch requirements for your boat.';
    if(i.cold)text='Look for stated insulation or cold-weather use. Full finger coverage alone does not establish warmth; check the product description and size guide.';
    if(i.waterproof&&i.family==='jackets')text='Check waterproof construction, intended conditions and fit. Water-repellent fabric alone does not establish waterproof protection.';
    if(i.guideRule?.guide && !text.includes(i.guideRule.guide))text+=' '+i.guideRule.guide;
    if(i.priceMax!==null||i.priceMin!==null)text+=' Your price limit is applied to the matching variant; other sizes or colors may cost more.';
    return text;
  }
  function refinements(i,matches) {
    const candidates=[];
    const add=(label,term)=>{if(!has(i.canonical||i.raw,term))candidates.push({label,query:(i.raw+' '+term).trim()});};
    const actual=new Set(matches.flatMap(m=>m.facts.features));
    if(i.family==='ropes'&&i.application==='halyard')for(const sail of ['main','jib','spinnaker']) {
      if(matches.some(m=>has(m.facts.collections,sail+' halyard')||has(m.facts.body,sail+' halyard')))add(sail[0].toUpperCase()+sail.slice(1)+' halyards',sail);
    }
    if(!i.waterproof&&['gloves','jackets','footwear','bags'].includes(i.family)&&matches.some(m=>m.facts.waterproof))add('Waterproof','waterproof');
    for(const f of features[i.family]||[])if(!i.features.includes(f)&&actual.has(f))add(f.replace(/\b\w/g,c=>c.toUpperCase()),f);
    if(!i.gender)for(const gender of ['men','women'])if(matches.some(m=>m.facts.gender===gender))add(gender==='men'?"Men’s":"Women’s",gender);
    if(!i.audience&&matches.some(m=>m.facts.audience==='junior'))add('Junior sizes','junior');
    if(!i.size&&i.family==='blocks')for(const size of [...new Set(matches.map(m=>m.facts.size).filter(Boolean))].sort((a,b)=>a-b))add(size+' mm sheave',size+'mm');
    if(!i.brands.length)for(const brand of [...new Set(matches.map(m=>m.facts.brand).filter(Boolean))]) {
      const b=config.brands.find(b=>b.key===brand);add(b.label,b.aliases[0]);
    }
    // Do not offer a refinement which produces zero matches in the observed result set.
    return candidates.filter(c=>{const next=parse(c.query);return matches.some(m=>match(m.product,next));}).slice(0,4);
  }
  return {config,norm,parse,url,facts,match,guidance,refinements,brandOf,rules};
})();

  const cache = new Map();
  const MAX_CACHE = 20;
  const TTL = 5 * 60 * 1000;
  let activeSearch = null;
  const visible = (el) => !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[hidden], [inert]');
  const focusables = (root) => [...root.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),[tabindex="0"]')].filter(visible);

  class VSSSmartSearch extends HTMLElement {
    connectedCallback() {
      if (this.events || !this.querySelector('form')) return;
      this.events = new AbortController();
      this.form = this.querySelector('form');
      this.input = this.form.querySelector('[name="q"]');
      const searchLocation=new URL(location.href);
      const readableQuery=searchLocation.searchParams.get('vss_query');
      if(searchLocation.pathname===new URL(this.form.action,location.origin).pathname) {
        const value=readableQuery||searchLocation.searchParams.get('q');
        if(value)this.input.value=value;
      }
      this.reset = this.form.querySelector('.js-search-reset');
      this.status = this.form.querySelector('[data-vss-status]');
      this.header = this.closest('store-header');
      this.mobileQuery = matchMedia('(max-width: 768px)');
      this.mobile = this.mobileQuery.matches;
      this.generation = 0;
      this.layer = this.querySelector('[data-vss-shell]').content.firstElementChild.cloneNode(true);
      document.body.append(this.layer);
      this.panel = this.layer.querySelector('.vss-search-panel');
      this.body = this.layer.querySelector('[data-vss-body]');
      this.heading = this.layer.querySelector('[data-vss-heading]');
      this.footer = this.layer.querySelector('.vss-search-footer');
      this.initialHTML = this.body.innerHTML;
      this.listen(this.form, 'focusin', (e) => {
        if (e.target === this.input && !this.suppressFocus) this.open();
      });
      this.listen(this.input, 'click', () => this.open());
      this.listen(this.input, 'input', () => { if (!this.composing) this.queryChanged(); });
      this.listen(this.input, 'compositionstart', () => { this.composing = true; this.invalidate(); });
      this.listen(this.input, 'compositionend', () => { this.composing = false; this.queryChanged(); });
      this.listen(this.reset, 'click', () => {
        this.input.value = '';
        this.queryChanged();
        this.input.focus({ preventScroll: true });
      });
      this.listen(this.form, 'submit', (e) => {
        if (!this.query()) { e.preventDefault(); this.input.focus(); return; }
        const intent=VSSIntent.parse(this.query());
        if(intent.clarify){e.preventDefault();this.open();this.renderClarification(intent);return;}
        if(intent.constrained || intent.changed) {
          e.preventDefault();const destination=this.fullSearchURL();this.close(false);window.location.assign(destination);return;
        }
        this.close(false);
      });
      this.listen(this.form, 'change', (e) => {
        if (e.target.closest('custom-select') && e.detail) {
          const hidden = this.form.querySelector('[name="filter.p.product_type"]');
          if (hidden) hidden.value = e.detail.selectedValue || '';
          this.queryChanged();
        }
      });
      this.listen(this.layer, 'click', (e) => {
        const refinement=e.target.closest('[data-vss-refine]');
        if(refinement&&!e.ctrlKey&&!e.metaKey&&!e.shiftKey&&!e.altKey&&e.button===0) {
          e.preventDefault();this.input.value=refinement.dataset.vssRefine;this.queryChanged();this.input.focus({preventScroll:true});return;
        }
        if (e.target.closest('[data-vss-dismiss]')) this.close(true);
        if (e.target.closest('[data-vss-retry]')) this.request();
      });
      this.listen(document, 'keydown', (e) => this.keydown(e), { capture: true });
      this.listen(document, 'click', (e) => this.documentClick(e), { capture: true });
      this.listen(document, 'focusin', (e) => {
        if (!this.isOpen || this.suppressFocus || this.form.contains(e.target) || this.layer.contains(e.target)) return;
        if (this.mobile) this.input.focus({ preventScroll: true });
        else this.close(false);
      });
      // Native menu opens on mouseenter. Keep the path from input to results safe;
      // explicit clicks/keyboard focus still hand control back to navigation.
      this.listen(document, 'mouseenter', (e) => {
        if (this.isOpen && e.target instanceof Element && e.target.closest('main-menu')) e.stopImmediatePropagation();
      }, { capture: true });
      this.listen(window, 'resize', () => this.scheduleGeometry(), { passive: true });
      this.listen(window, 'scroll', () => this.scheduleGeometry(), { passive: true });
      this.listen(window, 'pagehide', () => this.close(false));
      if (window.visualViewport) {
        this.listen(visualViewport, 'resize', () => this.scheduleGeometry(), { passive: true });
        this.listen(visualViewport, 'scroll', () => this.scheduleGeometry(), { passive: true });
      }
      this.listen(this.mobileQuery, 'change', () => {
        this.mobile = this.mobileQuery.matches;
        if (this.isOpen) {
          this.setPresentation();
          this.scheduleGeometry();
          this.input.focus({ preventScroll: true });
        }
      });
      this.resizeObserver = new ResizeObserver(() => this.scheduleGeometry());
      this.resizeObserver.observe(this.header || this);
      this.setupVoice();
      this.reset.hidden = !this.query();
      this.input.classList.toggle('search__input--dirty', !!this.query());
    }

    listen(target, type, handler, options = {}) {
      if (target) target.addEventListener(type, handler, { ...options, signal: this.events.signal });
    }
    query() { return this.input.value.trim(); }
    invalidate() {
      this.generation += 1;
      clearTimeout(this.debounceTimer);
      this.requestController?.abort();
    }
    queryChanged() {
      this.invalidate();
      this.reset.hidden = !this.query();
      this.input.classList.toggle('search__input--dirty', !!this.query());
      if (!this.isOpen) this.open(false);
      this.updateViewAll();
      if (!this.query()) { this.renderStart(); return; }
      this.renderLoading();
      this.debounceTimer = setTimeout(() => this.request(), 250);
    }

    open(load = true, opener = this.input) {
      if (this.isOpen) return;
      activeSearch?.close(false);
      this.closeMenus();
      this.opener = opener;
      this.isOpen = true;
      activeSearch = this;
      this.setAttribute('open', '');
      this.layer.hidden = false;
      this.scrollPosition = { x: scrollX, y: scrollY };
      const gap = Math.max(0, innerWidth - document.documentElement.clientWidth);
      this.savedBodyPad = document.body.style.getPropertyValue('--vss-search-body-pad');
      this.savedScrollY = document.body.style.getPropertyValue('--vss-search-scroll-y');
      document.body.style.setProperty('--vss-search-body-pad', `${parseFloat(getComputedStyle(document.body).paddingRight) + gap}px`);
      document.body.style.setProperty('--vss-search-scroll-y', `-${this.scrollPosition.y}px`);
      document.documentElement.classList.add('vss-search-locked');
      document.body.classList.add('vss-search-locked');
      this.setPresentation();
      this.geometry();
      this.watchMenus();
      if (this.mobile) this.input.focus({ preventScroll: true });
      this.updateViewAll();
      if (!this.query()) this.renderStart();
      else if (load) this.request();
    }

    close(restoreFocus = true) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.invalidate();
      this.recognition?.abort();
      this.menuObserver?.disconnect();
      this.removeAttribute('open');
      this.restoreBackground();
      this.restoreNavigation();
      this.restoreForm();
      this.layer.hidden = true;
      this.body.removeAttribute('aria-busy');
      this.status.textContent = '';
      document.documentElement.classList.remove('vss-search-locked');
      document.body.classList.remove('vss-search-locked', 'vss-search-mobile');
      for (const [key, value] of [['--vss-search-body-pad', this.savedBodyPad], ['--vss-search-scroll-y', this.savedScrollY]]) {
        if (value) document.body.style.setProperty(key, value);
        else document.body.style.removeProperty(key);
      }
      if (this.wasFixed) { scrollTo(this.scrollPosition.x, this.scrollPosition.y); this.wasFixed = false; }
      if (activeSearch === this) activeSearch = null;
      const fallback = this.mobile ? [...(this.header?.querySelectorAll('.js-show-search,.js-show-search-left') || [])].find(visible) : this.input;
      const focusTarget = this.opener?.isConnected && visible(this.opener) ? this.opener : fallback;
      if (restoreFocus && focusTarget?.isConnected && visible(focusTarget)) {
        this.suppressFocus = true;
        focusTarget.focus({ preventScroll: true });
        this.suppressFocus = false;
      }
    }

    setPresentation() {
      this.suppressFocus = true;
      if (this.mobile) {
        if (!this.formMarker) {
          this.formMarker = document.createElement('div');
          this.formMarker.setAttribute('aria-hidden', 'true');
          this.formMarker.style.height = `${this.form.getBoundingClientRect().height}px`;
          this.form.before(this.formMarker);
          this.layer.querySelector('.vss-search-field-dock').append(this.form);
        }
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        this.panel.setAttribute('aria-label', 'Search');
        document.body.classList.add('vss-search-mobile');
        this.wasFixed = true;
        this.hideBackground();
      } else {
        this.restoreBackground();
        this.restoreForm();
        this.panel.setAttribute('role', 'region');
        this.panel.removeAttribute('aria-modal');
        this.panel.setAttribute('aria-label', 'Search suggestions');
        document.body.classList.remove('vss-search-mobile');
        if (this.wasFixed) { scrollTo(this.scrollPosition.x, this.scrollPosition.y); this.wasFixed = false; }
      }
      if (!this.mobile) this.hideNavigation();
      else this.restoreNavigation();
      this.footer.hidden = !this.mobile || !this.query() || VSSIntent.parse(this.query()).clarify;
      this.suppressFocus = false;
    }

    hideNavigation() {
      if (this.navState) return;
      this.navState = new Map();
      this.header?.querySelectorAll('main-menu').forEach((menu) => {
        this.navState.set(menu, { inert: menu.inert, ariaHidden: menu.getAttribute('aria-hidden') });
        menu.inert = true;
        menu.setAttribute('aria-hidden', 'true');
      });
      this.header?.classList.add('vss-search-nav-covered');
    }
    restoreNavigation() {
      this.navState?.forEach((state, menu) => {
        menu.inert = state.inert;
        if (state.ariaHidden === null) menu.removeAttribute('aria-hidden');
        else menu.setAttribute('aria-hidden', state.ariaHidden);
      });
      this.navState = null;
      this.header?.classList.remove('vss-search-nav-covered');
    }

    restoreForm() {
      if (!this.formMarker) return;
      this.formMarker.replaceWith(this.form);
      this.formMarker = null;
    }
    hideBackground() {
      if (this.inertElements) return;
      this.inertElements = new Map();
      const hide = () => {
        for (const el of document.body.children) {
          if (el === this.layer || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName) || this.inertElements.has(el)) continue;
          this.inertElements.set(el, el.inert);
          el.inert = true;
        }
      };
      hide();
      this.backgroundObserver = new MutationObserver(hide);
      this.backgroundObserver.observe(document.body, { childList: true });
    }
    restoreBackground() {
      this.backgroundObserver?.disconnect();
      this.inertElements?.forEach((wasInert, el) => { el.inert = wasInert; });
      this.inertElements = null;
    }
    closeMenus() {
      document.querySelectorAll('main-menu').forEach((menu) => {
        clearTimeout(menu.menuLinkTimeout);
        clearTimeout(menu.singleLinkTimeout);
        const disclosures = [...menu.querySelectorAll('.main-nav__item--dropdown.is-open')];
        if (menu.mainContent?.classList.contains('is-open') || disclosures.length || menu.overlayOpen) {
          menu.opener = null;
          if (menu.mainContent?.classList.contains('is-open')) menu.closeMainMenu?.(false);
          disclosures.forEach((item) => menu.close?.(item, false));
          if (menu.overlayOpen) menu.toggleOverlay?.(false);
          menu.childNavOpen = false;
          if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
        }
      });
    }
    watchMenus() {
      this.menuObserver?.disconnect();
      this.menuObserver = new MutationObserver(() => {
        if (this.isOpen && document.querySelector('main-menu .main-nav__item--dropdown.is-open,main-menu .main-menu__content.is-open')) this.close(false);
      });
      document.querySelectorAll('main-menu').forEach((menu) => this.menuObserver.observe(menu, { attributes: true, attributeFilter: ['class'], subtree: true }));
    }
    documentClick(e) {
      const trigger = e.target.closest?.('.js-show-search,.js-show-search-left');
      if (trigger && this.header?.contains(trigger) && this.mobile) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open(true, trigger);
        this.input.focus({ preventScroll: true });
        return;
      }
      if (this.isOpen && !this.form.contains(e.target) && !this.layer.contains(e.target)) this.close(false);
    }

    keydown(e) {
      if (!this.isOpen || e.isComposing || this.composing) return;
      if (e.key === 'Escape') {
        // Let an open product-type select consume its own Escape first.
        if (e.target.closest('custom-select')?.listboxOpen) return;
        e.preventDefault(); e.stopImmediatePropagation(); this.close(true); return;
      }
      const links = [...this.body.querySelectorAll('a[href],button')].filter(visible);
      if (e.key === 'ArrowDown' && e.target === this.input && links.length) {
        e.preventDefault(); links[0].focus(); return;
      }
      const index = links.indexOf(e.target);
      if (index >= 0 && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        if (e.key === 'ArrowUp' && index === 0) this.input.focus({ preventScroll: true });
        else links[Math.max(0, Math.min(links.length - 1, index + (e.key === 'ArrowDown' ? 1 : -1)))].focus();
        return;
      }
      if (e.key === 'Tab' && this.mobile) {
        const items = focusables(this.panel);
        if (!items.length) { e.preventDefault(); this.panel.focus(); return; }
        if (e.shiftKey && (e.target === items[0] || !this.panel.contains(e.target))) { e.preventDefault(); items.at(-1).focus(); }
        else if (!e.shiftKey && (e.target === items.at(-1) || !this.panel.contains(e.target))) { e.preventDefault(); items[0].focus(); }
      } else if (e.key === 'Tab' && !this.mobile && !e.shiftKey && this.form.contains(e.target)) {
        const formItems = focusables(this.form);
        if (e.target === formItems.at(-1)) {
          const first = focusables(this.panel)[0];
          if (first) { e.preventDefault(); first.focus(); }
        }
      } else if (e.key === 'Tab' && !this.mobile && e.shiftKey && e.target === focusables(this.panel)[0]) {
        e.preventDefault(); focusables(this.form).at(-1)?.focus();
      }
    }

    fullSearchURL() {
      return VSSIntent.url(VSSIntent.parse(this.query()),this.form.action,location.origin,this.form.querySelector('[name="filter.p.product_type"]')?.value).href;
    }
    updateViewAll() {
      this.layer.querySelectorAll('[data-vss-viewall]').forEach((a) => {
        a.href = this.fullSearchURL();
        a.hidden = !this.query() || VSSIntent.parse(this.query()).clarify;
      });
      this.footer.hidden = !this.mobile || !this.query();
    }
    renderStart() {
      this.body.innerHTML = this.initialHTML;
      this.body.removeAttribute('aria-busy');
      this.layer.dataset.mode = 'start';
      this.heading.textContent = 'Search';
      this.status.textContent = '';
      this.updateViewAll();
    }
    renderLoading() {
      this.layer.dataset.mode = 'start';
      this.heading.textContent = 'Searching…';
      const box = document.createElement('div');
      box.className = 'vss-search-loading';
      const spinner = document.createElement('span');
      spinner.className = 'vss-search-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      box.append(spinner, document.createTextNode(this.dataset.loadingText || 'Loading…'));
      this.body.replaceChildren(box);
      this.body.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Searching…';
    }
    renderError() {
      this.layer.dataset.mode = 'error';
      this.heading.textContent = 'Search';
      const box = document.createElement('div');
      box.className = 'vss-search-error';
      const title = document.createElement('h3'); title.textContent = 'Suggestions could not load';
      const copy = document.createElement('p'); copy.textContent = 'Try again or open the full search results.';
      const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'vss-search-pill'; retry.dataset.vssRetry = ''; retry.textContent = 'Try again';
      box.append(title, copy, retry, this.helpLink());
      this.body.replaceChildren(box);
      this.body.removeAttribute('aria-busy');
      this.status.textContent = 'Search suggestions could not load. Try again or view all results.';
    }
    helpLink() {
      const a = document.createElement('a');
      a.className = 'vss-search-help'; a.href = this.dataset.helpUrl; a.textContent = 'Expert help →';
      return a;
    }
    ruleLinks(items, appendQuery='') {
      const ul=document.createElement('ul');ul.className='vss-search-links';
      for(const item of items) {
        if(!item.label||!item.query)continue;
        const query=appendQuery?(appendQuery+' '+item.query).trim():item.query;
        const li=document.createElement('li'),a=document.createElement('a'),label=document.createElement('span'),arrow=document.createElement('span');
        a.dataset.vssRefine=query;a.dataset.vssResultLink='';
        a.href=VSSIntent.url(VSSIntent.parse(query),this.form.action,location.origin,this.form.querySelector('[name="filter.p.product_type"]')?.value).href;
        label.textContent=item.label;arrow.textContent='→';arrow.setAttribute('aria-hidden','true');
        a.append(label,arrow);li.append(a);ul.append(li);
      }
      return ul;
    }
    renderClarification(intent) {
      const box=document.createElement('div');box.className='vss-search-empty';
      const h=document.createElement('h3');h.textContent=intent.rule?.heading||'What do you need it for?';
      const p=document.createElement('p');p.className='vss-search-guidance';p.textContent=intent.rule?.guide||'Choose an application to narrow your search.';
      box.append(h,p,this.ruleLinks(intent.rule?.choices||[]),this.helpLink());
      this.body.replaceChildren(box);this.body.removeAttribute('aria-busy');
      this.layer.dataset.mode='clarify';this.heading.textContent='Help with your search';
      this.status.textContent='Choose what you need the product for.';this.updateViewAll();
    }
    applyEditableGuidance(results,intent) {
      const rule=intent.guideRule;if(!rule)return;
      let grid=results.querySelector('.vss-search-grid');
      if(!grid) {
        grid=document.createElement('div');grid.className='vss-search-grid';
        const zone=document.createElement('div');zone.className='vss-search-products-zone';
        for(const node of [...results.children])if(node.tagName!=='TEMPLATE')zone.append(node);
        grid.append(zone);results.prepend(grid);
      }
      let aside=grid.querySelector('.vss-search-discover');
      if(!aside){aside=document.createElement('aside');aside.className='vss-search-discover';aside.setAttribute('aria-label','Search guidance');grid.prepend(aside);}
      if(rule.guide) {
        let h=aside.querySelector('h3');if(!h){h=document.createElement('h3');aside.prepend(h);}h.textContent='Suggestions';
        let p=aside.querySelector('.vss-search-guidance');if(!p){p=document.createElement('p');p.className='vss-search-guidance';h.after(p);}p.textContent=VSSIntent.guidance(intent);
      }
      const broadHalyard=rule.mode==='alias' && VSSIntent.norm(rule.target)==='halyard' && intent.application==='halyard' && !intent.brands.length && !intent.size && intent.priceMax===null && intent.priceMin===null && !/\b(main|mainsail|jib|genoa|spinnaker)\b/.test(intent.canonical||'');
      if(rule.choices?.length && (!intent.constrained || broadHalyard)) {
        aside.querySelectorAll('ul,h4').forEach(el=>el.remove());
        const h=document.createElement('h4');h.className='vss-search-refine-heading';h.textContent=rule.heading||'Refine your search';
        aside.append(h,this.ruleLinks(rule.choices,intent.raw));
      }
      grid.classList.add('vss-search-grid--discover');
      if(rule.replaceCollections) {
        const candidates=(rule.collections||[]).filter(c=>{
          if(!intent.brands.length)return true;
          const titleBrand=VSSIntent.brandOf(c.title);
          const vendors=[...new Set((c.vendors||[]).map(VSSIntent.brandOf).filter(Boolean))];
          return titleBrand?intent.brands.includes(titleBrand):vendors.length===1&&intent.brands.includes(vendors[0]);
        });
        if(candidates.length || !(rule.collections||[]).length)grid.querySelector('.vss-search-context')?.remove();
        if(candidates.length) {
          const related=document.createElement('aside');related.className='vss-search-context';related.setAttribute('aria-label','Related collections');
          const h=document.createElement('h3');h.textContent='Related collections';
          const p=document.createElement('p');p.className='vss-search-context-note';p.textContent='Explore this category. Check product details for your size and application.';
          const ul=document.createElement('ul');ul.className='vss-search-links';
          for(const c of candidates.slice(0,8)) {
            const u=new URL(c.url,location.origin);if(u.origin!==location.origin)continue;
            const li=document.createElement('li'),a=document.createElement('a');a.href=u.pathname+u.search;a.dataset.vssResultLink='';a.textContent=c.title+' →';li.append(a);ul.append(li);
          }
          related.append(h,p,ul);grid.append(related);
        }
      }
      grid.classList.toggle('vss-search-grid--context',!!grid.querySelector('.vss-search-context'));
      if(results.dataset.mode==='compact')results.dataset.mode='discovery';
    }

    applyContext(results) {
      const curated = results.querySelector('template[data-vss-curated]');
      if (!curated) {
        // Unknown families retain native discovery, without repeating the query.
        const normalize = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ');
        const seen = new Set([normalize(this.query())]);
        let kept = 0;
        results.querySelectorAll('.vss-search-discover li').forEach((item) => {
          const value = normalize(item.querySelector('a span')?.textContent || item.textContent.replace('→', ''));
          if (seen.has(value) || kept >= 3) item.remove();
          else { seen.add(value); kept += 1; }
        });
        const aside = results.querySelector('.vss-search-discover');
        if (aside && !aside.querySelector('li')) {
          aside.remove();
          results.querySelector('.vss-search-grid')?.classList.remove('vss-search-grid--discover');
        }
        return;
      }
      let grid = results.querySelector('.vss-search-grid');
      if (!grid) {
        grid = document.createElement('div');
        grid.className = 'vss-search-grid vss-search-grid--no-products';
        const empty = results.querySelector('.vss-search-empty');
        if (empty) {
          const zone = document.createElement('div');
          zone.className = 'vss-search-products-zone';
          zone.append(empty);
          grid.append(zone);
        }
        results.prepend(grid);
      }
      grid.querySelectorAll('.vss-search-discover,.vss-search-context').forEach((el) => el.remove());
      const guidance = curated.content.querySelector('.vss-search-discover');
      const context = curated.content.querySelector('.vss-search-context');
      if (guidance) grid.prepend(guidance.cloneNode(true));
      if (context) grid.append(context.cloneNode(true));
      grid.classList.toggle('vss-search-grid--discover', !!guidance);
      grid.classList.toggle('vss-search-grid--context', !!context);
      // Preserve the narrow exact-SKU presentation; contextual discovery expands.
      if (results.dataset.mode !== 'empty') results.dataset.mode = 'discovery';
      curated.remove();
    }

    applyIntent(results, refinedHTML) {
      const intent=VSSIntent.parse(this.query());
      if(!intent.family || intent.advanced || ['exact','matches'].includes(results.dataset.mode))return;
      const curated=results.querySelector('template[data-vss-curated]');
      const override=curated?.dataset.guideOverride==='true';
      this.applyContext(results);
      let grid=results.querySelector('.vss-search-grid');
      if(!grid) { grid=document.createElement('div');grid.className='vss-search-grid';results.prepend(grid); }
      let source=results;
      if(intent.constrained) {
        if(!refinedHTML)throw new Error('Missing filtered search response');
        source=new DOMParser().parseFromString(refinedHTML,'text/html').querySelector('[data-vss-search-page]');
        if(!source)throw new Error('Install search.vss-results.liquid with this version');
      }
      const matches=[];
      source.querySelectorAll('.vss-search-product').forEach(card=>{
        const raw=card.querySelector('[data-vss-facts]')?.getAttribute('data-vss-facts');
        if(!raw)return;
        const p=JSON.parse(raw), match=VSSIntent.match(p,intent);
        if(match)matches.push({...match,card});
      });
      matches.sort((a,b)=>b.score-a.score);
      let zone=grid.querySelector('.vss-search-products-zone');
      if(!zone) {zone=document.createElement('div');zone.className='vss-search-products-zone';grid.append(zone);}
      zone.replaceChildren();
      const title=document.createElement('h3');title.textContent='Products';zone.append(title);
      const list=document.createElement('ul');list.className='vss-search-products';zone.append(list);
      for(const match of matches.slice(0,5)) {
        const card=match.card.cloneNode(true), v=match.variant;
        if(v) {
          const anchor=card.querySelector('.vss-search-product-link');
          const productURL=new URL(anchor.getAttribute('href'),location.origin);
          productURL.searchParams.set('variant',String(v.id));anchor.setAttribute('href',productURL.pathname+productURL.search);
          const price=card.querySelector('.vss-search-price');price.textContent=v.money;
          card.querySelectorAll('.vss-search-variant,.vss-search-sku').forEach(el=>el.remove());
          if(v.title&&v.title!=='Default Title') {const el=document.createElement('span');el.className='vss-search-variant';el.textContent=v.title;price.before(el);}
          if(v.sku) {const el=document.createElement('span');el.className='vss-search-sku';el.textContent='SKU '+v.sku;price.before(el);}
        }
        card.querySelector('[data-vss-facts]')?.remove();
        list.append(card);
      }
      if(!matches.length) {
        const box=document.createElement('div');box.className='vss-search-empty';
        const h=document.createElement('h3');h.textContent='No matching products in this preview';
        const p=document.createElement('p');p.textContent='Try a broader search or open all results. Your size, brand and price requirements have not been relaxed.';
        box.append(h,p,this.helpLink());zone.append(box);
      } else if(intent.constrained&&Number(source.dataset.pages)>1) {
        const p=document.createElement('p');p.className='vss-search-context-note';p.textContent='Preview of matching products. Open all results to explore more.';zone.append(p);
      }
      let aside=grid.querySelector('.vss-search-discover');
      if(!aside) {aside=document.createElement('aside');aside.className='vss-search-discover';aside.setAttribute('aria-label','Search guidance');grid.prepend(aside);}
      if(!override) {
        // Preserve server-curated broad browsing links only for broad queries.
        const oldLinks=!intent.constrained?aside.querySelector('.vss-search-links')?.cloneNode(true):null;
        aside.replaceChildren();
        const h=document.createElement('h3');h.textContent='Suggestions';
        const p=document.createElement('p');p.className='vss-search-guidance';p.textContent=VSSIntent.guidance(intent);aside.append(h,p);
        const suggestions=VSSIntent.refinements(intent,matches);
        if(oldLinks?.querySelector('li'))aside.append(oldLinks);
        else if(suggestions.length) {
          const h4=document.createElement('h4');h4.className='vss-search-refine-heading';h4.textContent='Refine your search';aside.append(h4);
          const ul=document.createElement('ul');ul.className='vss-search-links';aside.append(ul);
          for(const suggestion of suggestions) {
            const li=document.createElement('li'),a=document.createElement('a'),label=document.createElement('span'),arrow=document.createElement('span');
            label.textContent=suggestion.label;arrow.textContent='→';arrow.setAttribute('aria-hidden','true');
            a.setAttribute('data-vss-refine',suggestion.query);a.setAttribute('data-vss-result-link','');
            a.href=VSSIntent.url(VSSIntent.parse(suggestion.query),this.form.action,location.origin,this.form.querySelector('[name="filter.p.product_type"]')?.value).href;
            a.append(label,arrow);li.append(a);ul.append(li);
          }
        } else if(oldLinks)aside.append(oldLinks);
        else {
          const a=document.createElement('a');a.className='vss-search-help';a.textContent='Help choosing the right product →';a.href=this.dataset.helpUrl;aside.append(a);
        }
      }
      const related=grid.querySelector('.vss-search-context');
      if(related&&!override) {
        related.querySelectorAll('li').forEach(li=>{
          const a=li.querySelector('a'),brand=a?.dataset.vssBrand;
          if(intent.family==='ropes'&&intent.application==='halyard'&&/anchor|mooring|dock|furling|terminator|end fitting/i.test(li.textContent+' '+(a?.getAttribute('href')||'')))li.remove();
          else if(intent.brands.length&&brand&&!intent.brands.includes(brand))li.remove();
        });
        if(!related.querySelector('li'))related.remove();
        else if(intent.constrained&&related.querySelector('.vss-search-context-note'))related.querySelector('.vss-search-context-note').textContent='Browse the full category by brand. Collections may include other sizes and configurations.';
      }
      grid.classList.add('vss-search-grid--discover');
      grid.classList.toggle('vss-search-grid--context',!!grid.querySelector('.vss-search-context'));
      grid.classList.toggle('vss-search-grid--no-products',!matches.length);
      results.dataset.mode='discovery';results.dataset.heading='Products';results.dataset.productCount=String(Math.min(matches.length,5));
      results.querySelectorAll('[data-vss-facts]').forEach(el=>el.remove());
    }

    renderResponse(html, refinedHTML = null) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const results = doc.querySelector('#shopify-section-vss-smart-search [data-vss-results], [data-vss-results]');
      if (!results) throw new Error('Missing search section');
      if (!['exact', 'matches'].includes(results.dataset.mode)) {
        const intent=VSSIntent.parse(this.query());
        if(intent.family&&!intent.advanced)this.applyIntent(results,refinedHTML);
        else this.applyContext(results);
        this.applyEditableGuidance(results,intent);
      }
      this.body.replaceChildren(document.importNode(results, true));
      this.layer.dataset.mode = results.dataset.mode;
      this.heading.textContent = results.dataset.heading;
      this.body.removeAttribute('aria-busy');
      this.body.scrollTop = 0;
      if (results.dataset.mode === 'empty') {
        this.body.querySelector('.vss-search-empty').append(this.helpLink());
        this.status.textContent = `No suggestions for ${this.query()}. Try another term or view all results.`;
      } else {
        const count = this.body.querySelectorAll('.vss-search-product').length;
        this.status.textContent = `${count} product ${count === 1 ? 'suggestion' : 'suggestions'} for ${this.query()}. ${results.dataset.mode === 'exact' ? 'Exact identifier match.' : ''} View all results for more.`;
      }
      this.updateViewAll();
    }

    async request() {
      if (!this.isOpen || !this.query() || this.composing) return;
      this.invalidate();
      const version = this.generation;
      const controller = new AbortController();
      this.requestController = controller;
      const query = this.query();
      const intent = VSSIntent.parse(query);
      if(intent.clarify){this.renderClarification(intent);return;}
      const url = new URL(this.dataset.endpoint || `${window.Shopify?.routes?.root || '/'}search/suggest`, location.origin);
      const type = this.form.querySelector('[name="filter.p.product_type"]')?.value;
      const escapedType = type?.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      url.searchParams.set('q', type ? `product_type:"${escapedType}" AND ${intent.canonical || query}` : (intent.canonical || query));
      url.searchParams.set('resources[type]', 'product,query,collection,page,article');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('section_id', 'vss-smart-search');
      const filteredURL=intent.constrained?VSSIntent.url(intent,this.form.action,location.origin,type):null;
      if(filteredURL)filteredURL.searchParams.set('view','vss-results');
      const key = `${filteredURL?.href||''}|${query}|${url.href}|${document.documentElement.lang}|${this.dataset.currency || window.Shopify?.currency?.active || ''}`;
      const cached = cache.get(key);
      if (cached && Date.now() - cached.at < TTL) {
        cache.delete(key); cache.set(key, cached);
        this.renderResponse(cached.html,cached.refinedHTML); return;
      }
      if (cached) cache.delete(key);
      this.renderLoading();
      let timedOut = false;
      const timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 8000);
      try {
        const fetchHTML=async endpoint=>{
          const response=await fetch(endpoint,{signal:controller.signal,headers:{Accept:'text/html'},credentials:'same-origin'});
          if(!response.ok)throw new Error(`Search HTTP ${response.status}`);
          return response.text();
        };
        const [html,refinedHTML]=await Promise.all([fetchHTML(url),filteredURL?fetchHTML(filteredURL):Promise.resolve(null)]);
        if (version !== this.generation || !this.isOpen || !this.isConnected) return;
        this.renderResponse(html,refinedHTML);
        cache.delete(key); cache.set(key, { at: Date.now(), html, refinedHTML });
        while (cache.size > MAX_CACHE) cache.delete(cache.keys().next().value);
      } catch (error) {
        controller.abort();
        if (version !== this.generation || !this.isOpen || !this.isConnected) return;
        if (error.name !== 'AbortError' || timedOut) this.renderError();
      } finally {
        clearTimeout(timeout);
      }
    }

    scheduleGeometry() {
      if (!this.isOpen || this.geometryFrame) return;
      this.geometryFrame = requestAnimationFrame(() => { this.geometryFrame = null; this.geometry(); });
    }
    geometry() {
      if (!this.isOpen) return;
      const viewport = window.visualViewport;
      const height = viewport?.height || innerHeight;
      this.layer.style.setProperty('--vss-search-vv-height', `${height}px`);
      this.layer.style.setProperty('--vss-search-vv-top', `${viewport?.offsetTop || 0}px`);
      this.layer.dataset.keyboard = String(this.mobile && innerHeight - height > 140);
      if (!this.mobile) {
        const rect = (this.header || this.form).getBoundingClientRect();
        const left = this.header ? Math.max(0, rect.left) : 0;
        const width = this.header ? Math.min(document.documentElement.clientWidth - left, rect.width) : document.documentElement.clientWidth;
        // The compact header has two grid rows. Cover navigation (row 2),
        // while keeping the logo/search/actions (row 1) visible and operable.
        const menu = [...(this.header?.querySelectorAll('main-menu') || [])]
          .find((el) => el.getBoundingClientRect().height > 0);
        const menuRect = menu?.getBoundingClientRect();
        const formRect = this.form.getBoundingClientRect();
        const edge = menuRect && menuRect.top >= formRect.bottom - 2 ? menuRect.top : rect.bottom;
        const top = Math.max(0, Math.min(edge, innerHeight - 120));
        this.layer.style.setProperty('--vss-search-top', `${top}px`);
        this.layer.style.setProperty('--vss-search-left', `${left}px`);
        this.layer.style.setProperty('--vss-search-width', `${width}px`);
        this.layer.style.setProperty('--vss-search-height', `${Math.max(80, innerHeight - top - 12)}px`);
      }
    }
    setupVoice() {
      const button = this.form.querySelector('[data-vss-voice]');
      const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!button || !Recognition) return;
      button.hidden = false;
      this.recognition = new Recognition();
      this.recognition.lang = document.documentElement.lang || 'en-US';
      this.recognition.interimResults = false;
      this.recognition.onresult = (e) => {
        if (!this.isOpen) return;
        this.input.value = e.results[0][0].transcript;
        this.queryChanged();
        this.input.focus({ preventScroll: true });
      };
      this.recognition.onerror = (e) => { if (this.isOpen && e.error !== 'aborted') this.status.textContent = 'Voice search is unavailable. Please type your search.'; };
      this.recognition.onend = () => button.removeAttribute('aria-pressed');
      this.listen(button, 'click', () => {
        this.open(false);
        try { this.recognition.start(); button.setAttribute('aria-pressed', 'true'); this.status.textContent = 'Listening…'; }
        catch { this.recognition.stop(); }
      });
    }
    disconnectedCallback() {
      if (!this.events) return;
      this.close(false);
      this.invalidate();
      this.events.abort(); this.events = null;
      this.resizeObserver?.disconnect(); this.menuObserver?.disconnect();
      cancelAnimationFrame(this.geometryFrame); this.geometryFrame = null;
      this.recognition?.abort();
      this.layer?.remove();
    }
  }
  customElements.define('vss-smart-search', VSSSmartSearch);
  document.addEventListener('shopify:section:load',()=>{cache.clear();if(activeSearch?.isOpen)activeSearch.queryChanged();});

  const restoreReadableSearch=()=>{
    const current=new URL(location.href),raw=current.searchParams.get('vss_query');
    const readable=raw||current.searchParams.get('q');
    document.querySelectorAll('[data-vss-readable-query]').forEach(el=>{el.textContent=readable?'Results for “'+readable+'”':'';el.hidden=!readable;});
    if(!raw)return;
    document.querySelectorAll('form').forEach(form=>{
      if(!form.querySelector('input[type="hidden"][name="q"]')||form.querySelector('[name="vss_query"]'))return;
      const input=document.createElement('input');input.type='hidden';input.name='vss_query';input.value=raw;form.append(input);
    });
    document.querySelectorAll('[data-vss-query-message]').forEach(el=>{
      const technical=el.dataset.vssQueryMessage;
      if(technical)el.textContent=el.textContent.replace(technical,raw);
    });
    document.querySelectorAll('facet-filters a[href]').forEach(a=>{
      const href=a.getAttribute('href');if(!href||href.startsWith('#'))return;
      const u=new URL(href,location.href);
      if(u.origin===current.origin&&u.pathname===current.pathname&&u.searchParams.get('q')===current.searchParams.get('q')) {
        u.searchParams.set('vss_query',raw);a.href=u.href;
      }
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restoreReadableSearch,{once:true});
  else restoreReadableSearch();
  // Full results use the same conservative product checks as the preview.
  const fullSearchFacts=new WeakMap();
  let fullSearchObserver=null,fullSearchRoot=null;
  const refreshFullSearch=()=>{
    const current=new URL(location.href),raw=current.searchParams.get('vss_query');
    const root=document.querySelector('[data-vss-full-results]');
    if(!raw||!root)return;
    const intent=VSSIntent.parse(raw);
    if(!intent.constrained||intent.advanced)return;
    for(const [param,key,combine] of [['filter.v.price.lte','priceMax',Math.min],['filter.v.price.gte','priceMin',Math.max]]) {
      const value=current.searchParams.get(param);
      if(value!==null&&value!==''&&Number.isFinite(Number(value))) {
        const cents=Math.round(Number(value)*100);
        intent[key]=intent[key]===null?cents:combine(intent[key],cents);
      }
    }
    let total=0,visible=0;
    root.querySelectorAll('[data-vss-full-card]').forEach(card=>{
      let product=fullSearchFacts.get(card);
      if(!product) {
        const node=card.querySelector('[data-vss-facts]');
        if(!node){card.hidden=true;card.style.display='none';return;}
        try {product=JSON.parse(node.getAttribute('data-vss-facts'));}catch{card.hidden=true;card.style.display='none';return;}
        fullSearchFacts.set(card,product);node.remove();
      }
      total++;
      const match=VSSIntent.match(product,intent);
      card.hidden=!match;card.style.display=match?'':'none';
      if(!match)return;
      visible++;
      const v=match.variant;
      if(v) {
        card.querySelectorAll('a[href]').forEach(a=>{
          const u=new URL(a.getAttribute('href'),location.origin);
          if(!u.pathname.includes('/products/'+product.handle))return;
          u.searchParams.set('variant',String(v.id));a.href=u.pathname+u.search;
        });
        // Keep the full product card's own variant controls and price intact.
        // A separate link states the exact option satisfying this search.
        let note=card.querySelector('[data-vss-matching-option]');
        if(!note) {note=document.createElement('a');note.dataset.vssMatchingOption='';note.className='block text-sm mt-2 underline';card.append(note);}
        const target=new URL('/products/'+product.handle,location.origin);target.searchParams.set('variant',String(v.id));
        note.href=target.pathname+target.search;
        note.textContent='Matching option: '+(v.title&&v.title!=='Default Title'?v.title+' · ':'')+v.money+' →';
      }
    });
    let note=root.querySelector('[data-vss-full-note]');
    if(!note) {note=document.createElement('p');note.dataset.vssFullNote='';note.className='mb-8';note.setAttribute('role','status');root.prepend(note);}
    const more=!!root.querySelector('.js-pagination a[href]');
    note.textContent=visible?`${visible} matching product${visible===1?'':'s'} shown. ${VSSIntent.guidance(intent)}`:
      'No products on this page meet all your requirements. '+(more?'Check another page or refine your search.':'Try a broader search or ask for help choosing a product.');
    if(total!==visible&&more)note.textContent+=' More matches may appear on other pages.';
    // Native facet counts describe the broader retrieval set, not strict matches.
    document.querySelectorAll('facet-filters .filter__count').forEach(el=>{el.hidden=true;});
    document.querySelectorAll('facet-filters .js-close-drawer-mob').forEach(el=>{el.textContent='Show results';});
    root.querySelectorAll('.js-pagination-message,.js-pagination-bar').forEach(el=>{el.hidden=true;});
    root.querySelectorAll('.js-pagination a[href]').forEach(a=>{
      const u=new URL(a.getAttribute('href'),location.origin);u.searchParams.set('vss_query',raw);a.href=u.href;
    });
    if(root!==fullSearchRoot&&typeof MutationObserver!=='undefined') {
      fullSearchObserver?.disconnect();fullSearchRoot=root;
      fullSearchObserver=new MutationObserver(records=>{
        if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-vss-full-card],.js-pagination')||n.querySelector?.('[data-vss-full-card],.js-pagination'))))) {
          restoreReadableSearch();refreshFullSearch();
        }
      });
      fullSearchObserver.observe(root,{childList:true,subtree:true});
    }
  };
  const refreshSearchPage=()=>{restoreReadableSearch();refreshFullSearch();};
  document.addEventListener('on:facet-filters:updated',refreshSearchPage);
  window.addEventListener?.('popstate',refreshSearchPage);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshSearchPage,{once:true});
  else refreshSearchPage();

})();
